import api from './client';

export interface SupportFaqEntry {
  id: number;
  question: string;
  answer: string;
  is_active: boolean;
  sort_order: number;
  created_at: string | null;
}

export interface SupportQueryLog {
  id: number;
  question: string;
  answer: string | null;
  answered_from: 'faq' | 'ai' | 'fallback';
  created_at: string | null;
}

export interface TopQuestion {
  question: string;
  count: number;
}

export interface SupportWidgetSettings {
  enabled: boolean;
  heading: string;
  accent_color: string;
}

export const supportFaqApi = {
  list: (page = 1) =>
    api.get<{ data: SupportFaqEntry[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/support-faq?page=${page}`
    ),

  create: (payload: { question: string; answer: string }) =>
    api.post<{ data: SupportFaqEntry }>('/support-faq', payload),

  update: (id: number, payload: Partial<Pick<SupportFaqEntry, 'question' | 'answer' | 'is_active' | 'sort_order'>>) =>
    api.patch<{ data: SupportFaqEntry }>(`/support-faq/${id}`, payload),

  destroy: (id: number) => api.delete(`/support-faq/${id}`),

  queries: (page = 1) =>
    api.get<{ data: SupportQueryLog[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/support-queries?page=${page}`
    ),

  topQuestions: () => api.get<{ data: TopQuestion[] }>('/support-queries/top'),

  settings: () => api.get<{ data: SupportWidgetSettings }>('/support-widget'),

  updateSettings: (payload: SupportWidgetSettings) =>
    api.put<{ data: SupportWidgetSettings }>('/support-widget', payload),
};
